// extracted by mini-css-extract-plugin
export default {"fr-view":"LegendPin_fr-view__6nmrA","legend-pin":"LegendPin_legend-pin__ayiGZ","isCorrect":"LegendPin_isCorrect__YIHcC","isReport":"LegendPin_isReport__33Jpy"};